import { render, staticRenderFns } from "./CompanyOrderPieceAddEditView.vue?vue&type=template&id=480845ee&scoped=true&"
import script from "./CompanyOrderPieceAddEditView.vue?vue&type=script&lang=js&"
export * from "./CompanyOrderPieceAddEditView.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOrderPieceAddEditView.vue?vue&type=style&index=0&id=480845ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480845ee",
  null
  
)

export default component.exports